export const SET_PRINT_CONTENT = 'SET_PRINT_CONTENT';
export const SET_PRINT_TYPE = 'SET_PRINT_TYPE';
export const SET_PRINT_CONTENT_ONLY = 'SET_PRINT_CONTENT_ONLY';
export const CLOSE_PRINT_CONTENT = 'CLOSE_PRINT_CONTENT';
